<template>
  <!-- :modal="modal" -->
  <el-dialog class="base-dialog" v-bind="$attrs" :width="width" :modal-append-to-body="modal"
             :append-to-body="bodyModal" :close-on-click-modal="closeOnClickModal"
             :visible.sync="dialogVisible" :show-close="showClose" :before-close="handleClose"
             @closed="handleClosed" @open="handleOpen">
    <div slot="title" class="el-dialog__title">
      <div class="title">
        <img class="title-img-left" src="../assets/imgs/memory/title_left.png" alt="">
        <span class="title-text">
          <slot name="title">标题</slot>
        </span>
        <img class="title-img-right" src="../assets/imgs/memory/title_right.png" alt="">
      </div>
      <div class="split-line"></div>
    </div>
    <slot></slot>
    <div slot="footer" v-show="showButton">
      <el-button class="close-btn" size="small" @click="handleClose">
        <slot name="close">{{$t('common.cancel')}}</slot>
      </el-button>
      <el-button class="confirm-btn" type="primary" size="small" v-show="showConfirmButton"
                 @click="handleConfirm">
        <slot name="confirm">{{$t('common.ok')}}</slot>
      </el-button>
      <slot name="footer-text"></slot>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'BaseDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    modal: {
      type: Boolean,
      default () {
        return true
      }
    },
    bodyModal: {
      type: Boolean,
      default () {
        return false
      }
    },
    width: {
      type: String,
      default () {
        return '480px';
      },
    },
    closeOnClickModal: {
      type: Boolean,
      default () {
        return false;
      }
    },
    showClose: {
      type: Boolean,
      default () {
        return true;
      },
    },
    showButton: {
      type: Boolean,
      default () {
        return true;
      }
    },
    showConfirmButton: {
      type: Boolean,
      default () {
        return true;
      },
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
    },
    handleConfirm: _.throttle(async function () {
      this.$emit('handleConfirm');
    }, 1500, {
      leading: true,
      trailing: false
    }),
    handleClosed () {
      this.$emit('handleClosed');
    },
    handleOpen () {
      this.$emit('handleOpen');
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
}
/deep/.el-dialog__header {
  padding-bottom: 20px;
  .el-dialog__title {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
      margin-bottom: 10px;
      .title-img-left {
        margin-right: 11px;
      }
      .title-text {
        font-size: 18px;
        font-weight: bold;
        color: #566087;
      }
      .title-img-right {
        margin-left: 11px;
      }
    }
    .split-line {
      width: 100%;
      height: 1px;
      background: #566087;
      opacity: 0.1;
    }
  }
  .el-dialog__headerbtn {
    font-size: 20px;
  }
}
/deep/.el-dialog__body {
  // padding: 0 56px 0 20px;
  padding: 0;
}
/deep/.el-dialog__footer {
  padding-top: 0;
  text-align: center;
  .el-button {
    padding: 8px 15px;
    width: 76px;
    font-size: 14px;
  }
  .el-button + .el-button {
    margin-left: 20px;
  }
  .close-btn {
    // background: #ffffff;
    // border: 1px solid #0078fc;
    border-radius: 4px;
    // color: #0078fc;
    // &:hover {
    //   background: lighten($color: #0078fc, $amount: 45%);
    // }
  }
}
</style>